// import HyperLinkColumn from "@/components/functionals/HyperLinkColumn.vue";
//import HyperlinkForResultsStatus from "@/components/functionals/HyperlinkForResultsStatus";
import HyperlinkForBudgetMaster from "@/components/functionals/HyperLinkForBudgetMaster.vue";

const Months = (thiss) => [
  {
    prop: "cuenta",
    name: "Cuenta",
    label: "Cuenta",
    minWidth: 120,
    fixed: true,
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "nombre",
    name: "Nombre Cuenta",
    label: "Nombre Cuenta",
    minWidth: 250,
    fixed: true,
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "ene",
    name: "Enero",
    label: "Enero",
    minWidth: 150,
    cellAtrrs: {
      mes: 1,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "feb",
    name: "Febrero",
    label: "Febrero",
    minWidth: 150,
    cellAtrrs: {
      mes: 2,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "mar",
    name: "Marzo",
    label: "Marzo",
    minWidth: 150,
    cellAtrrs: {
      mes: 3,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "abr",
    name: "Abril",
    label: "Abril",
    minWidth: 150,
    cellAtrrs: {
      mes: 4,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "may",
    name: "Mayo",
    label: "Mayo",
    minWidth: 150,
    cellAtrrs: {
      mes: 5,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "jun",
    name: "Junio",
    label: "Junio",
    minWidth: 150,
    cellAtrrs: {
      mes: 6,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "jul",
    name: "Julio",
    label: "Julio",
    minWidth: 150,
    cellAtrrs: {
      mes: 7,
      editEneable: thiss.editEneable,
      mes2: "July",
      updatingAccountValue: thiss.updatingAccountValue
    },
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "ago",
    name: "Agosto",
    label: "Agosto",
    minWidth: 150,
    cellAtrrs: {
      mes: 8,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "sep",
    name: "Septiembre",
    label: "Septiembre",
    cellAtrrs: {
      mes: 9,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    minWidth: 150,
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "oct",
    name: "Octubre",
    label: "Octubre",
    cellAtrrs: {
      mes: 10,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    minWidth: 150,
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "nov",
    name: "Noviembre",
    label: "Noviembre",
    cellAtrrs: {
      mes: 11,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    minWidth: 150,
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "dic",
    name: "Diciembre",
    label: "Diciembre",
    cellAtrrs: {
      mes: 12,
      editEneable: thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue
    },
    minWidth: 150,
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  },
  {
    prop: "tot",
    name: "Total",
    label: "Total",
    minWidth: 150,
    fixed: "right",
    //formatter: thiss.editEneable === true ? HyperlinkForBudgetMaster : HyperlinkForResultsStatus
    formatter: HyperlinkForBudgetMaster
  }
];

const Actions = [
  {
    icon: "el-icon-edit",
    label: "Editar Montos",
    command: "edit-amount-acc",
    condition: (row) => row.negrita !== "S" && row.negrita !== "T"
  }
];

export { Months, Actions };
